import { render, staticRenderFns } from "./SurfaceList.vue?vue&type=template&id=30af8527&scoped=true"
import script from "./SurfaceList.vue?vue&type=script&lang=js"
export * from "./SurfaceList.vue?vue&type=script&lang=js"
import style0 from "./SurfaceList.vue?vue&type=style&index=0&id=30af8527&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30af8527",
  null
  
)

export default component.exports